export function currencyFormatter(value) {
  const formattedValue = value.toLocaleString("en-GB", {
    style: "currency",
    currency: "GBP",
  });
  return formattedValue.substring(0, formattedValue.indexOf("."));
}
